import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CURRENCY_CODES, CURRENCIES } from "../lib/currency";

export default function CurrencySelect({ value, onChange, testid = "currency-select", className = "" }) {
  return (
    <Select value={value || "USD"} onValueChange={onChange}>
      <SelectTrigger className={`bg-[#FFFFFF] border-[#E4E7EC] ${className || "w-full"}`} data-testid={testid}>
        <SelectValue/>
      </SelectTrigger>
      <SelectContent className="bg-[#FFFFFF] border-[#E4E7EC]">
        {CURRENCY_CODES.map(c => (
          <SelectItem key={c} value={c}>{CURRENCIES[c].symbol} {CURRENCIES[c].label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
